const OrderDateRange = {
  LAST_THREE_MONTHS: 0,
  THIS_YEAR: 100,
  LAST_YEAR: 200,
  TWO_YEARS_AGO: 300,
  THREE_YEARS_AGO: 400,
  FOUR_YEARS_AGO: 500,
  FIVE_YEARS_AGO: 600,
};

export default OrderDateRange;
